import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource } from '@angular/material/table';
import { TranslatePipe, TranslationService } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { ColumnConfig } from 'material-dynamic-table';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { TableComponent } from '../../../../table/table.component';

@Component({
  selector: 'app-error-list-modal',
  templateUrl: './error-list-modal.component.html',
  styleUrls: ['./error-list-modal.component.scss'],
  providers: [AsyncPipe],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, TableComponent, AsyncPipe, TranslatePipe],
})
export class ErrorListModalComponent implements OnInit {
  cartId: string;

  columns: ColumnConfig[] = [
    {
      name: 'column',
      displayName: this.compareDefaultValue(
        this.pipeAsync.transform(this.getTranslatedValue(`shimano.import.error.columnDisplayName.column`))
      ),
      type: 'string',
      sort: false,
    },
    {
      name: 'row',
      displayName: this.compareDefaultValue(
        this.pipeAsync.transform(this.getTranslatedValue(`shimano.import.error.columnDisplayName.row`))
      ),
      type: 'string',
      sort: false,
    },
    {
      name: 'details',
      displayName: this.compareDefaultValue(
        this.pipeAsync.transform(this.getTranslatedValue(`shimano.import.error.columnDisplayName.details`))
      ),
      type: 'string',
      sort: false,
    },
  ];

  errorListData: any;
  dataSource = new MatTableDataSource<any>();

  constructor(
    protected modalService: StandardModalService,
    private cdr: ChangeDetectorRef,
    private cartService: CartExtendService,
    private breakpointService: BreakpointService,
    private translation: TranslationService,
    private pipeAsync: AsyncPipe
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => (this.cartId = res.cartId));
  }

  ngOnInit() {
    this.getErrorList(this.cartId);
  }

  getErrorList(code: any) {
    this.cartService.getImportCartErrorList(code).subscribe((data) => {
      this.errorListData = this.mappedSavedCartImportErrors(data.comments);
      this.dataSource = this.errorListData;
      this.cdr.detectChanges();
    });
  }

  get isDesktop$(): Observable<boolean> {
    return this.breakpointService.breakpoint$.pipe(map((breakpoint) => breakpoint === BREAKPOINT.xl));
  }

  getTranslatedValue(key: string, param?: string): Observable<string> {
    return param ? this.translation.translate(key, { quantity: param.trim() }) : this.translation.translate(key);
  }

  mappedSavedCartImportErrors(importErrorsData: any[]) {
    return importErrorsData.map((data) => {
      let translatedColumnValue;
      let translatedDetailsValue;

      if (data.column.indexOf(': ') > 0) {
        if (data.column.indexOf('shimano.savedcart') >= 3) {
          let splitData = data.column.split(': ')[1];
          translatedColumnValue = this.pipeAsync.transform(this.getTranslatedValue(splitData));
        }
      } else {
        translatedColumnValue = this.pipeAsync.transform(this.getTranslatedValue(data.column));
      }

      if (data.details.indexOf(':') < 0) {
        if (data.details.indexOf('exception.savedcart') >= 0) {
          translatedDetailsValue = this.pipeAsync.transform(this.getTranslatedValue(data.details));
        } else {
          if (data.details === 'product.not.found') {
            translatedDetailsValue = this.pipeAsync.transform(
              this.getTranslatedValue('exception.savedcart.product.not.found')
            );
          } else {
            translatedDetailsValue = data.details;
          }
        }
      } else {
        translatedDetailsValue = this.pipeAsync.transform(
          this.getTranslatedValue(data.details.split(':')[0], data.details.split(':')[1])
        );
        // when translation key doesn't exist and details return null
        if (translatedDetailsValue !== null) {
          if (translatedDetailsValue.split(':').length > 0 && translatedDetailsValue.indexOf('[') === 0) {
            translatedDetailsValue = data.details;
          }
        }
      }

      if (translatedDetailsValue === null) {
        translatedDetailsValue = data.details;
      }

      return {
        ...data,
        column: this.compareDefaultValue(translatedColumnValue),
        details: this.compareDefaultValue(translatedDetailsValue),
      };
    });
  }

  compareDefaultValue(value: string): string {
    return value.charAt(0) === '[' && value.charAt(value.length - 1) === ']' ? value.slice(1, -1) : value;
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }
}
